export const topics = [
  {
    id: "annual-best",
    title: "年度佳片",
    subtitle: "盘点这一年真正值得反复回味的电影",
    cover: "https://readdy.ai/api/search-image?query=stylish%20cinema%20collage%20art%2C%20vintage%20film%20reels%20and%20golden%20award%20light%20rays%20on%20deep%20navy%20background%2C%20warm%20orange%20accents%2C%20editorial%20painterly%20illustration%2C%20no%20text&width=800&height=600&seq=topic-cover-01&orientation=landscape",
    count: 24,
    accent: true,
  },
  {
    id: "web-hot",
    title: "网红剧集",
    subtitle: "全网热议，一集接一集停不下来",
    cover: "https://readdy.ai/api/search-image?query=cozy%20late%20night%20living%20room%20with%20a%20glowing%20tv%20and%20popcorn%2C%20warm%20orange%20lamp%20light%20against%20deep%20blue%20room%2C%20cinematic%20painterly%20illustration%2C%20no%20text&width=800&height=600&seq=topic-cover-02&orientation=landscape",
    count: 18,
    accent: false,
  },
  {
    id: "sci-fi",
    title: "科幻宇宙",
    subtitle: "从星海到深海，一次看尽浪漫与想象",
    cover: "https://readdy.ai/api/search-image?query=abstract%20cosmic%20nebula%20with%20a%20small%20spaceship%20silhouette%2C%20deep%20indigo%20and%20glowing%20orange%20star%2C%20dreamy%20painterly%20illustration%2C%20no%20text&width=800&height=600&seq=topic-cover-03&orientation=landscape",
    count: 15,
    accent: false,
  },
  {
    id: "classic",
    title: "经典重温",
    subtitle: "那些被时间证明过的好故事",
    cover: "https://readdy.ai/api/search-image?query=vintage%20retro%20cinema%20interior%20with%20red%20velvet%20seats%20and%20projector%20beam%2C%20dusty%20warm%20sepia%20and%20navy%20tones%2C%20nostalgic%20painterly%20illustration%2C%20no%20text&width=800&height=600&seq=topic-cover-04&orientation=landscape",
    count: 30,
    accent: false,
  },
];